import { PagePersonal } from './Personal';

export const USER = {
  Personal: PagePersonal,
} as const;
